<template>
    <Modal v-model:visible="visible">
        <template v-slot:header>
            <div>
                <h2 class="text-lg font-bold">Nuovo figlio</h2>
            </div>
        </template>
        <template v-slot:main>
            <div class="flex-grow pt-5">
                <div class="flex flex-col mb-3">
                    <div>Nome</div>
                    <input v-model="nome" placeholder="Nome"
                           class="col-span-3 p-2 bg-next-gray-md">
                    <span v-if="figlio_modal_error.nome"
                          class="text-next-orange font-bold text-sm">{{ figlio_modal_error.nome }}</span>
                </div>
                <div class="flex flex-col mb-3">
                    <div>Sesso</div>
                    <select v-model="sesso"
                            class="col-span-3 p-2 bg-next-gray-md">
                        <option value="M">Maschio</option>
                        <option value="F">Femmina</option>
                    </select>
                    <span v-if="figlio_modal_error.sesso"
                          class="text-next-orange font-bold text-sm">{{ figlio_modal_error.sesso }}</span>
                </div>
                <div class="flex flex-col mb-3">
                    <div>Anno nascita</div>
                    <input v-model="eta" placeholder="Età"
                           type="number" min="0" max="255"
                           class="col-span-3 p-2 bg-next-gray-md">
                    <span v-if="figlio_modal_error.eta"
                          class="text-next-orange font-bold text-sm">{{ figlio_modal_error.eta }}</span>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end pt-3">
                <NextButton variant="outline-secondary"
                    @click="$emit('update:visible', false)"
                    class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
                <NextButton variant="primary"
                    @click="addFiglio"
                    class="ml-4 py-2 px-4">
                    Aggiungi
                </NextButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'ModalFigli',
    components: {
        Modal,
        NextButton
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
    }
})
export default class ModalFigli extends Vue {
    visible!: boolean

    nome = ''
    sesso = ''
    eta: string | null = null

    figlio_modal_error = {
        nome: '',
        sesso: '',
        eta: ''
    }

    reset() {
        this.nome = ''
        this.sesso = ''
        this.eta = ''
    }

    addFiglio() {
        let error = false
        this.figlio_modal_error.nome = this.nome ? '' : 'Questo campo è obbligatorio'
        this.figlio_modal_error.sesso = this.sesso ? '' : 'Questo campo è obbligatorio'
        this.figlio_modal_error.eta = this.eta ? (Number.isInteger(parseFloat(this.eta)) ? ((parseFloat(this.eta) >= 0 && parseFloat(this.eta) < 255) ? '' : 'Questo campo deve essere minore di 255 e maggiore o uguale di 0') : 'Questo campo deve essere naturale') : 'Questo campo è obbligatorio'

        error = !(!this.figlio_modal_error.eta && !this.figlio_modal_error.nome && !this.figlio_modal_error.sesso)
        if (!error) {
            this.figlio_modal_error.nome = ''
            this.figlio_modal_error.sesso = ''
            this.figlio_modal_error.eta = ''
            this.$emit('add', {nome: this.nome, sesso: this.sesso, eta: this.eta,})
            this.$emit('update:visible', false)
            this.reset()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
